<template>
  <div>
    <van-dialog
      v-model="isRate"
      show-cancel-button
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <p style="padding: 0.3rem; font-size: 0.35rem">
        当前系统无法获取到检测结果，请输入相似比继续，如18.60
      </p>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0.2rem 0;
        "
      >
        <input type="text" v-model="inputrate" />
        <span>%</span>
      </div>
      <div style="display: flex; justify-content: space-around">
        <p style="padding: 0.3rem" @click="isRate = false">取消</p>
        <p style="padding: 0.3rem; color: #228ef7" @click="sureDialog()">
          确认
        </p>
      </div>
    </van-dialog>
    <div class="title-box">
      <van-icon name="arrow-left" class="lefticon" @click="goBack()" />
      <p>查看报告</p>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <div class="result-container" style="font-size: 0.3rem">
      <div class="result-summary">
        <p>论文题目：{{ order.title }}</p>
        <p>论文作者：{{ order.writer }}</p>
        <p>
          检测结果：{{ order.timer ? order.timer + "%" : "-" }}
          (以报告内显示为准)
        </p>
        <p>检测系统：{{ order.bbname }}</p>
        <p>提检时间：{{ order.date_pay }}</p>
      </div>
      <div class="result-btn">
        <div
          @click="toPdf(order)"
          class="result-action result-action-primary"
          v-if="canPreview"
        >
          在线预览检测报告
        </div>
        <div
          @click="openSendEmail(order)"
          class="result-action result-action-secondary"
        >
          发送报告到邮箱保存
        </div>
        <div
          @click="todownload(order)"
          class="result-action result-action-download"
        >
          下载完整检测报告
        </div>
        <a
          class="result-action result-action-service"
          href="https://chatbot.weixin.qq.com/webapp/Ws75Px9atGV9s4UkR64nosl5FI8L7b?isFloat=false&robotName=%E4%B8%87%E6%96%B9%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D"
        >
          在线客服
        </a>
      </div>
      <div style="margin-top: 0.7rem">
        <p>注：</p>
        <p>1、检测报告线上仅保存10天，请及时下载保存；</p>
        <p>2、完整报告需用WinRAR等软件解压后才能查看。</p>
      </div>
    </div>
    <div class="modals modals-bottom-dialog" v-if="isSend">
      <div class="modals-cancel"></div>
      <div class="bottom-dialog-body bottom-pos">
        <div class="emailtext">
          发送报告到邮箱
          <div class="cansolex" @click="closeBtn">✘</div>
        </div>
        <input
          name="email"
          type="text"
          class="emailstyle"
          placeholder="请填写接收报告的邮箱地址"
          v-model="emailtext"
        />
        <div class="emailexplain">
          将发送查重后的报告到你的邮箱，稍后请查收，建议下载长期保存，如未收到，到邮箱垃圾箱内查看
        </div>
        <button class="sendbtn" @click="formSubmit(emailtext)">发送</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      order: {},
      isSend: false,
      show: false,
      ylshow: false,
      isRate: false,
      inputrate: "",
      src: "",
      actions: [
        { name: "直接下载", color: "#228ef7", className: "ftactions" },
        { name: "复制下载链接", color: "#228ef7", className: "ftactions" },
        { name: "发送到邮箱", color: "#228ef7", className: "ftactions" },
        { name: "取消", color: "#228ef7", className: "ftactions" },
      ],
      emailtext: "",
      emaimsg: "",
      isphone: false,
    };
  },
  computed: {
    canPreview() {
      return !!(this.order.api_orderid || this.order.report_pdf_path || this.order.orderid);
    },
  },
  created() {
    this.order = this.$route.query;
    if (this.order.phone) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  methods: {
    sureDialog(e) {
      if (this.inputrate !== "") {
        this.isRate = false;
        this.$router.push({
          path: "/qrimg",
          query: {
            title: this.order.title,
            writer: this.order.writer,
            newrate: this.inputrate,
            bbname: this.order.bbname,
            tjtime: this.order.date_pay,
          },
        });
      }
    },
    toPdf(e) {
      if (e.report) {
        window.location.href = e.report;
        return;
      }

      const token = window.sessionStorage.getItem("Token");
      if (e.orderid && token) {
        const previewUrl = `https://www.wanfangtest.com/report/${e.orderid}/preview?token=${encodeURIComponent(token)}`;
        window.location.href = previewUrl;
        return;
      }

      if (e.api_orderid) {
        window.location.href = `https://view.checklike.com/report/review?orderid=${e.api_orderid}`;
      }
    },
    goBack() {
      this.$router.back();
    },
    formSubmit(e) {
      let reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
      if (!reg.test(e)) {
        Toast.fail("请输入正确邮箱格式");
      } else {
        let order = this.emaimsg.id;
        if (this.isphone) {
          this.$http.getNoToEmail(order, { email_address: e }).then((res) => {
            Toast(
              "发送成功,请到邮箱查看报告。如未收到可能是被拦截了，可到垃圾箱内查找或者联系客服。"
            );
            this.isSend = false;
          });
        } else {
          this.$http.getToEmail(order, { email_address: e }).then((res) => {
            Toast(
              "发送成功,请到邮箱查看报告。如未收到可能是被拦截了，可到垃圾箱内查找或者联系客服。"
            );
            this.isSend = false;
          });
        }
      }
    },
    todownload(msg) {
      this.actions[0].id = msg.orderid;
      this.actions[1].id = msg.orderid;
      this.show = true;
      this.emaimsg = msg;
    },
    openSendEmail(msg) {
      this.emaimsg = msg;
      this.isSend = true;
    },
    closeBtn() {
      this.isSend = false;
    },
    copyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        var msg = document.execCommand("copy") ? "成功" : "失败";
        Toast.success("复制成功");
      } catch (err) {}
      document.body.removeChild(textArea);
    },
    onSelect(item) {
      console.log(item, 321);
      if (item.name == "直接下载") {
        window.open(`https://www.wanfangtest.com/orders/${item.id}/download`);
        this.show = false;
      } else if (item.name == "复制下载链接") {
        let url = `https://www.wanfangtest.com/orders/${item.id}/download`;
        this.copyTextToClipboard(url);
        console.log(url, 123);
        this.show = false;
      } else if (item.name == "发送到邮箱") {
        this.show = false;
        this.isSend = true;
      } else if (item.name == "取消") {
        this.show = false;
      }
    },
  },
};
</script>

<style scoped>
.result-btn {
  margin-top: 0.7rem;
}
.result-summary {
  padding-bottom: 0.28rem;
  border-bottom: 1px solid #edf2f7;
}
.result-action {
  width: 6rem;
  text-align: center;
  color: #fff;
  padding: 0.23rem 0;
  margin: 0 auto 0.4rem;
  border-radius: 0.16rem;
  font-weight: 600;
  box-shadow: 0 0.1rem 0.24rem rgba(15, 23, 42, 0.08);
}
.result-action-primary {
  background: #228ef7;
}
.result-action-secondary {
  background: #08cf01;
}
.result-action-download {
  background: #05b20b;
}
.result-action-service {
  display: block;
  background: #f59e0b;
}
.title-box {
  display: flex;
  background: #228ef7;
}
.title-box p {
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  flex: 0.85;
}
.lefticon {
  line-height: 0.8rem;
  padding: 0 0.3rem;
  color: #fff;
  font-size: 0.4rem;
}
.result-container {
  padding: 0.3rem;
  padding-bottom: 0.8rem;
}
.result-container p {
  margin-bottom: 0.3rem;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 0.4rem;
}
.result-box {
  display: flex;
  justify-content: space-between;
  margin: 0.1rem 0;
  align-items: center;
}
.result-box-bg {
  background-color: #0498fa;
  color: #fff;
  font-size: 0.3rem;
  padding: 0 0.1rem;
  height: 0.5rem;
  line-height: 0.5rem;
}
.word >>> .mark-red {
  color: red;
}

.word >>> .section {
  text-indent: 0.7rem;
  font-size: 0.33rem;
  line-height: 0.5rem;
}

.bottom-dialog-body {
  position: absolute;
  z-index: 10001;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
}

.modals {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.modals-cancel {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.emailtext {
  font-size: 16px;
  background-color: #ccc;
  height: 0.73rem;
  line-height: 0.73rem;
  padding-left: 0.3rem;
}

.cansolex {
  float: right;
  font-size: 16px;
  padding-right: 0.3rem;
}

.sendbtn {
  display: block;
  border: none;
  height: 0.6rem;
  background-color: #228ef7;
  border-radius: 5%;
  color: #fff;
  line-height: 0.6rem;
  width: 90%;
  margin: 0.3rem auto;
}

.emailexplain {
  padding: 0 0.6rem;
  font-size: 13px;
  line-height: 0.5rem;
  color: #8b8386;
  text-indent: 0.3rem;
}

.emailstyle {
  border: 1px solid #ccc;
  display: block;
  margin: 0.16rem auto;
  width: 75%;
  padding-left: 3%;
  height: 0.65rem;
  line-height: 0.65rem;
  font-size: 16px;
  color: #8b8386;
}

.van-action-sheet__name {
  font-size: 0.32rem;
}
.noreport {
  font-size: 0.31rem;
  color: red;
  height: 12rem;
  padding: 0.3rem 0;
  margin-top: 0.7rem;
  text-align: center;
}
</style>
